import { render, staticRenderFns } from "./FlightsFooter.vue?vue&type=template&id=75eaa4bf&"
import script from "./FlightsFooter.vue?vue&type=script&lang=js&"
export * from "./FlightsFooter.vue?vue&type=script&lang=js&"
import style0 from "./FlightsFooter.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports